import { Sub } from "@radix-ui/react-dropdown-menu";

export const DropdownMenuSub = Sub;
